import { CommonFormGrid } from 'components/form/grid';
import { FormHeading } from 'components/form/heading';
import { FormSelect } from 'components/form/select';
import { FormTextField } from 'components/form/textfield';
import { EB } from 'components/layout/error-boundary';
import { FormContext } from 'contexts/form';
import { OptionDef } from 'interfaces/options';
import { PriceDoc } from 'lib/interfaces/database/price';
import { StringUtil } from 'lib/utilities/string';
import { useContext, useEffect, useMemo, useState } from 'react';
import useSecuritiesStore from 'stores/securities';

export const PriceForm = () => {
  const { data: securities, load: loadSecurities } = useSecuritiesStore();

  useEffect(() => {
    loadSecurities();
  }, []);

  const { data, setData } = useContext(FormContext);

  const [defaultData] = useState<Partial<PriceDoc>>(data);

  const securityOptions = useMemo<OptionDef[]>(() => {
    return securities.map((o) => ({
      label: o.name,
      value: o.id,
      group: o._issuer?.name,
    }));
  }, [securities]);

  return (
    <EB>
      <CommonFormGrid columns="2">
        <FormHeading label="Historical Price" gridColumn="span 2" />

        <FormTextField
          gridColumn="span 2"
          label="Effective Date"
          defaultValue={StringUtil.printDate(defaultData.effective)}
          onChange={(v) => {
            const payload: Partial<PriceDoc> = {
              effective: v,
            };
            setData(payload);
          }}
          required
        />

        <FormSelect
          gridColumn="span 2"
          label="Security"
          defaultValue={defaultData.securityID}
          options={securityOptions}
          onChange={(v) => {
            const payload: Partial<PriceDoc> = {
              securityID: v,
            };
            setData(payload);
          }}
          required
        />

        <FormTextField
          gridColumn="span 2"
          label="Price Per Share"
          defaultValue={defaultData.pps?.toString()}
          onNumericChange={(v) => {
            const payload: Partial<PriceDoc> = {
              pps: v,
            };
            setData(payload);
          }}
          required
        />

        <FormTextField
          label="Face Value"
          defaultValue={defaultData.face?.toString()}
          onOptionalNumericChange={(v) => {
            const payload: Partial<PriceDoc> = {
              face: v,
            };
            setData(payload);
          }}
        />

        <FormTextField
          label="Par Value"
          defaultValue={defaultData.par?.toString()}
          onOptionalNumericChange={(v) => {
            const payload: Partial<PriceDoc> = {
              par: v,
            };
            setData(payload);
          }}
        />
      </CommonFormGrid>
    </EB>
  );
};
